// @flow

import { registerPosthogListeners } from './posthog'
import { registerMetricEventListeners } from './metricEvents'
import { registerPostMessageEventListeners } from './postMessage'
import { registerChatchampPixelListeners } from './chatchampPixel'

export function registerChatbotEventListeners (): void {
  registerPosthogListeners()
  registerMetricEventListeners()
  registerPostMessageEventListeners()
  registerChatchampPixelListeners()
}
